// pages/PageImageToday.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Pagination, Button } from "@mui/material";
import { useNavigate } from "react-router";
import Impressions from "../../../composant/impressions/impressions";
import { useImpressions } from "../../../service/useImpressions";
import ImprimantSucces from "../../../composant/message/imprimanteSucces";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import { Api_Token } from "../../../env";

export default function PageImageToday() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const [images, setImages] = useState([]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const GetImage = useCallback(async () => {
    try {
      const res = await Api_Token.get(
        `/command/GetImagesToday?page=${currentPage}`
      );
      setData(res.data);

      // ✅ فلترة العناصر التي تحتوي على ImageTraites فقط
      const validImages =
        res.data?.data?.filter((item) => item.ImageTraites?.length > 0) || [];
      setImages(validImages);
    } catch (error) {
      console.error("error get photos : ", error);
      setImages([]);
    }
  }, [currentPage]);

  useEffect(() => {
    GetImage();
  }, [GetImage]);

  const {
    allImages,
    selectedImages,

    loading,
    openPopup,
    handleSelectImage,
    handleSelectAll,
    editImage,
    setOpenPopup,
    downloadImage,
  } = useImpressions(images || [], 0, data?.imprimant);
  console.log("images  :", images);
  console.log("all images  :", allImages);
  return (
    <Box>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Traitement des images
      </Typography>
      <Box sx={{ height: "130vh" }}>
        <Impressions
          allImages={allImages}
          selectedImages={selectedImages}
          handleSelectImage={handleSelectImage}
          handleDownloadImage={downloadImage}
          editImage={editImage}
        />
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={data?.totalPages || 0}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="flex-end"
        mt={2}
        gap={2}
        p={2}
        position="fixed"
        bottom={0}
        width="100%"
        bgcolor="background.paper"
        boxShadow={3}
      >
        <Button variant="contained" onClick={handleSelectAll}>
          {selectedImages?.length === images?.length
            ? "Désélectionner tout"
            : "Sélectionner tout"}
        </Button>
        <Button variant="contained">photos today</Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => navigate("/admin")}
        >
          Close
        </Button>
      </Box>
      <ImprimantSucces
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
          navigate("/admin/searchCommand");
        }}
      />
      <BackLoadingSimple open={loading} />
    </Box>
  );
}
